import { Mail, MapPin, Phone } from "lucide-react";
import { useDesign, useSite } from "../context/SiteContext";

export const Footer = () => {
  const b = useSite()?.brand;
  const light = useDesign() === "minimal";
  if (!b) return null;
  const tone = light ? "border-t border-ink/10 bg-linen text-ink/70" : "bg-shade text-paper/70";
  const head = light ? "text-ink" : "text-paper";
  return (
    <footer className={`mt-24 ${tone}`} data-testid="site-footer">
      <div className="container-x grid gap-8 py-12 md:grid-cols-[1.2fr_1fr]">
        <div>
          <p className={`font-serif text-2xl ${head}`}>{b.name}</p>
          <p className="mt-1 text-sm">{b.footer_text}</p>
        </div>
        <ul className="space-y-2 text-sm">
          {b.phone && <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-gold" />{b.phone}</li>}
          {b.email && <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-gold" />{b.email}</li>}
          {b.address && <li className="flex items-start gap-2"><MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" />{b.address}</li>}
        </ul>
      </div>
      <div className={`container-x border-t py-5 font-mono text-xs uppercase tracking-[0.2em] ${light ? "border-ink/10" : "border-paper/10"}`} data-testid="footer-copyright">
        © {new Date().getFullYear()} {b.name}
      </div>
    </footer>
  );
};
